(function () {
    'use strict';

    angular.module('PWAPoCApp').directive('completedStopActionButtons', completedStopActionButtons);

    completedStopActionButtons.$inject = [];

    function completedStopActionButtons() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/shared/directives/routeStopCard/completed-stop-action-buttons.html',
            transclude: true,
            link: link
        };

        return directive;

        function link(scope, element, attrs) {

            
        }
    }
})();